import { cognitoConfig } from "./cognitoConfig";


export const exchangeCognitoCode = async (code) => {
  const body = new URLSearchParams({
    grant_type: 'authorization_code',
    client_id: cognitoConfig.clientId,
    redirect_uri: cognitoConfig.redirectUri,
    code,
  });

  const response = await fetch(
    `https://${cognitoConfig.domain}/oauth2/token`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: body.toString(),
    }
  );

  if (!response.ok) {
    throw new Error('Failed to exchange Cognito auth code');
  }

  return response.json();
};
